import { render, staticRenderFns } from "./certificado.vue?vue&type=template&id=5a303cf4&scoped=true"
import script from "./certificado.vue?vue&type=script&lang=js"
export * from "./certificado.vue?vue&type=script&lang=js"
import style0 from "./certificado.vue?vue&type=style&index=0&id=5a303cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a303cf4",
  null
  
)

export default component.exports